import { render, staticRenderFns } from "./SeminarTabsTag.vue?vue&type=template&id=3bcdd90c&"
import script from "./SeminarTabsTag.vue?vue&type=script&lang=js&"
export * from "./SeminarTabsTag.vue?vue&type=script&lang=js&"
import style0 from "./SeminarTabsTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports